<script setup lang="ts">
/**
 * Wraps a PDP product focus module to expose its position to the
 * `EditorialProductFocusButton` CTA (PF001 GA event).
 */
const props = defineProps<{ position: number }>()

provideProductFocusPosition(props.position)
</script>

<template>
  <slot />
</template>
